import React from 'react'
import { ReactComponent as ArrowRolloverLogoLeftSvg} from '../../assets/svgs/arrows/Arrow_Rollover_Logo_Left.svg';

const ArrowRolloverLogoLeftIcon = () => (
    <div>
        <ArrowRolloverLogoLeftSvg/>
    </div>
)

export default ArrowRolloverLogoLeftIcon